module.exports = "../../app/cells/components/modals/questions_review_suggestion_modal/show.erb";